import { useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import Event1 from "../../assets/images/Home Page/1.jpg";
import Event2 from "../../assets/images/Home Page/2.jpg";
import Event3 from "../../assets/images/Home Page/3.jpg";
import Event4 from "../../assets/images/Home Page/4.jpg";
import Event5 from "../../assets/images/Home Page/5.jpg";
import Event6 from "../../assets/images/Home Page/6.jpg";
import Event8 from "../../assets/images/Home Page/pic.jpg";

import BlueImage from "../../assets/images/blue.jpeg";

import pagination from "../utilities/pagination";
const arraImages = [
  {
    id: 1,
    image: Event6,
    Link: "#",
  },
  {
    id: 7,
    image: Event8,
    Link: "#",
  },
  {
    id: 6,
    image: Event5,
    Link: "#",
  },
  {
    id: 2,
    image: Event1,
    Link: "#",
  },
  {
    id: 3,
    image: Event2,
    Link: "#",
  },
  {
    id: 4,
    image: Event3,
    Link: "#",
  },
  {
    id: 5,
    image: Event4,
    Link: "#",
  },
  
];
const ImageGallery = () => {
  // Define a state variable to keep track of the selected image
  const [selectedImage, setSelectedImage] = useState(null);

  // Define a function to handle clicks on the images
  const handleClick = (image) => {
    setSelectedImage(image);
  };

  // Define a function to handle clicks on the "x" button
  const handleReset = () => {
    setSelectedImage(null);
  };

  return (
    <Container>
      <h2 className="text-center bg-dark text-light display-4 my-3 rounded-pill py-3 my-4">
        التصريحات و البيانات
      </h2>
      <Row className="justify-content-center">
        {/* Display eight images */}

        {arraImages.map((image, index) => (
          <Col
            lg={4}
            md={6}
            key={index}
            className="mb-4"
            style={{
              cursor: "pointer",
            }}
          >
            <Image
              className="gallery-image rounded-4"
              src={image.image}
              fluid
              onClick={
                image.id === 1
                  ? () => {
                      window.open(
                        "https://youtube.com/@saudalasfoor.campaign6640",
                        "_blank"
                      );
                    }
                  : () => handleClick(image.image)
              }
              style={{
                border: "1px solid var(--primary-color)",
              }}
            />
          </Col>
        ))}
      </Row>

      {/* If a selected image is found, display the enlarged image */}
      {selectedImage && (
        <div className="enlarged-image d-flex justify-content-center align-items-center">
          <div style={{ position: "relative" }}>
            <Image
              className="rounded-4 "
              src={selectedImage}
              fluid
              style={{ width: "650px", height: "650px" }}
            />
            <button className="close-button btn btn-dark" onClick={handleReset}>
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
      )}

      <style jsx>{`
        .enlarged-image {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 99922;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, #fbfbfc 0%, #f6f7f9 100%);
        }

        .close-button {
          position: absolute;
          top: -15px;
          right: -0px;
          font-size: 1.5rem;
          padding: 0.5rem;
          border-radius: 50%;
          width: 50px;
        }
      `}</style>
    </Container>
  );
};

export default ImageGallery;
